const data = [
  {
    id: '1',
    name: 'Kennedy',
    job: 'Chief Mobility Orchestrator',
    city: 'North Alec',
  },
  {
    id: '2',
    name: 'Lucius',
    job: 'Internal Research Manager',
    city: 'Littleland',
  },
  {
    id: '3',
    name: 'Carlos',
    job: 'Lead Configuration Analyst',
    city: 'South Lillian',
  },
  {
    id: '4',
    name: 'Urban',
    job: 'Chief Operations Agent',
    city: 'Shieldshaven',
  },
  {
    id: '5',
    name: 'Katrine',
    job: 'Legacy Solutions Orchestrator',
    city: 'South Kyleigh',
  },
];
export default data;
